import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export const formatCurrency = str => {
  if (!str) return "";

  return Number(str).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
};

export const formatProductDate = date => {
  return date
    ? format(parseISO(date), "EEEE, d MMMM yyyy", { locale: ptBR })
    : "";
};

export const formatProductDateToTable = date => {
  return date
    ? format(parseISO(date), "dd/MM/yyyy HH:mm", { locale: ptBR })
    : "";
};

export const formatOrderStatus = status => {
  switch (status) {
    case "RE":
      return "Reservado";
    case "PA":
      return "Pago";
    case "CA":
      return "Cancelado";
    default:
      return "Pago";
  }
};
